export function BrandFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="mx-auto max-w-3xl px-6 pb-12 pt-4 text-center text-sm text-bloudraad-light-text-muted dark:text-bloudraad-dark-text-muted">
      <p>&copy; {year} bloudraad.</p>
    </footer>
  );
}
